import { Component, OnInit } from '@angular/core';
import { LANGUAGE_CONSTANTS as LANG_CONST } from 'src/app/shared/constants/language-constants';
import { LocalizationService } from 'src/app/shared/services/localization.service';

@Component({
  selector: 'app-select-site',
  templateUrl: './select-site.component.html',
  styleUrls: ['./select-site.component.scss'],
})
export class SelectSiteComponent {
  // constant declarations
  readonly LANG_CONST = LANG_CONST;

  constructor(private localizationService: LocalizationService) {
    this.localizationService.setupLocalization();
  }
}
